<template>
<div class="login_body">
  <div class="login">
    <el-form
      ref="AccountFrom"
      :model="account"
      :rules="rules"
      label-position="top"
      label-width="80px"
      class="demo-ruleForm login-container"
    >
      <h3 class="title">DDS数据分发与缴存系统</h3>
      <el-form-item label="用户名" prop="username" size="large">
        <el-input type="text" v-model="account.username" placeholder="账号"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="pwd" size="large">
        <el-input type="password" v-model="account.pwd" placeholder="密码"></el-input>
      </el-form-item>
      <!-- <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox> -->
      <el-form-item style="width:100%; margin-top: 84px;" size="large">
        <el-button
          type="primary"
          style="width:100%;"
          @click.native.prevent="handleLogin"
          :loading="loading"
        >登 录</el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="login-footer">
    <div>
      <p class="footer-title">"联系与支持　|　Copyright 2020 China Science Publishing & Media Ltd.　中国科技出版传媒股份有限公司　京ICP备14028887号-24"</p>
    </div>
  </div>
</div>
</template>

<script>
import API_ADMIN from "../api/api_user";
import util from "../common/util";
import {validaePass} from "../common/validator";

export default {
  data() {
    return {
      loading: false,
      account: {
        username: "admin",//admin
        pwd: ""//admin123456
      },
      rules: {
        username: [
          { required: true, message: "请输入账号", trigger: "blur" }
          //{ validator: validaePass }
        ],
        pwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          //{ validator: validaePass, trigger: "blur" }
        ]
      },
      checked: true
    };
  },
  methods: {
    handleLogin() {
      let that = this;
      this.$refs.AccountFrom.validate(valid => {
        if (valid) {
          this.loading = true;
          //采用RSA加密登录密码
          let rsaPwd = util.rsaCrypt.rsaEncrypt(this.account.pwd);
          console.log("rsaPwd:" + rsaPwd);
          //const address = require('address');
          let loginParams = {username: this.account.username, 
                              password: rsaPwd};
          //发送http请求
          API_ADMIN.login(loginParams)
            .then(res => {
                that.loading = false;
                console.log("..........login res:" + res);
                if (0 === res.errorCode) {
                  this.$message({
                    type: "success",
                    message: "用户登录成功!"
                  });
                  //将访问token、刷新token、token有效时间保持 JSON.stringify
                  console.log("..........login accessToken:" + res.accessToken);
                  console.log("..........login refreshToken:" + res.refreshToken);
                  console.log("..........login expiresIn:" + res.expiresIn);
                  console.log("..........login roles:" + res.roles);
                  sessionStorage.setItem('roles',res.roles);
                  sessionStorage.setItem("userName", this.account.username);
                  sessionStorage.setItem("accessToken", res.accessToken);
                  sessionStorage.setItem("refreshToken", res.refreshToken);
                  //expiresIn时间单位为s
                  //sessionStorage.setItem("expiresIn", res.expiresIn);
                  //开启刷新token定时器
                  util.isRefreshTokenExpired(res.expiresIn);

                  //进入管理后台页面
                  let roles = sessionStorage.getItem('roles');
                  
                  if(roles.indexOf('process') >= 0){
                    that.$router.push({ path: "/resultMng/processData"});
                  }
                  else if(roles.indexOf('upload') >=0 ){
                    that.$router.push({ path: "/resultMng/journalData" });
                  }
                  else if(roles.indexOf('audit') >=0 ){
                    that.$router.push({ path: "/resultMng/journalDataAudit" });
                  }
                  else if(roles.indexOf('latex') >= 0){
                    that.$router.push({ path: "/resultMng/autoTypeset" });
                  }
                  else{
                    that.$router.push({ path: "/resultMng/transLog" });
                  }
                  
                  //that.$router.push({ path: "/resultMng" });
                } 
                else {
                  //登录失败，清除缓存，回到登录页面
                  sessionStorage.removeItem('accessToken');
                  sessionStorage.removeItem('refreshToken');
                  sessionStorage.removeItem('expiresIn');
                  this.$router.push('/login');
                  //登录失败提示
                  that.$message({
                  showClose: true,
                  message: res.errorInfo || "登录失败",
                  type: "error"
                });
                }
              })
            .catch(e => {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    }
  },
};
</script>
<style>
  .login_body{
    height: 100%;
    width: 100%;
    position: fixed;
    background-image: linear-gradient(to top, #30cfd0 0%, #330867 100%);
  }
  .login {
    font-family: 微软雅黑;
    width: 800px;
    height: 534px;
    padding-left: 340px;
    position: absolute;
    left: calc(50% - 580px);
    top: calc(50% - 300px);
    z-index: 99;
    border-radius: 10px;
    margin: 0px;
    background: #fff url("../assets/images/login_page.png") no-repeat;
  }
  .login_footer{
    width: 100%;
    position: fixed;
    bottom: 0;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  .footer-title{
    width: 100%;
    position: fixed;
    bottom: 0;
    height: 80px;
    line-height: 80px;
    text-align: center;
    color: #fff;
  }
  body {
    background: #eee;
  }
</style>
<style lang="scss" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    position: absolute;
    left: calc(50% - 100px);
    top: calc(50% - 250px);
    width: 416px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    
    background: -ms-linear-gradient(top, #ace, #00C1DE); /* IE 10 */
    background: -moz-linear-gradient(top, #ace, #00C1DE); /*火狐*/
    background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#ace), to(#00C1DE)); /*谷歌*/
    background: -webkit-linear-gradient(top, #ace, #00C1DE); /*Safari5.1 Chrome 10+*/
    background: -o-linear-gradient(top,#ace, #00C1DE); /*Opera 11.10+*/

    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
      font-size: 25px;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue